export default "__VITE_ASSET__NZVQaLej__"